const o = "_scrollContainer_1oxrx_2", l = {
  scrollContainer: o
};
export {
  l as default,
  o as scrollContainer
};
//# sourceMappingURL=ScrollBarContainer.module.scss.js.map
